import { CustomData } from 'owa-analytics-actions';
import { logUsage } from 'owa-analytics';

export function logUnsampledNotesDataPoint(eventName: string, customData?: CustomData): void {
    logUsage(eventName, customData, {
        isCore: true,
    });
}
